<template>
    <div :class="containerClass" class="py-2">
        <div v-if="!showCreation">
            <div v-for="(answer, index) in validAnswers" :key="index">
                <hr />
                <p class="subtitle is-size-6 lb-answer">
                    {{ answer.value }}
                </p>
            </div>
        </div>
        <div v-if="showCreation">
            <div class="control">
                <div class="select is-fullwidth">
                    <select v-model="answerTypeLocal">
                        <option :value="'EMPTY'" disabled>
                            {{ $t(`creation.answer_type.select`) }}
                        </option>
                        <option
                            v-for="answerType in answerTypes"
                            :key="answerType"
                            :value="answerType"
                        >
                            {{ $t(`creation.answer_type.${answerType}`) }}
                        </option>
                    </select>
                </div>

                <p
                    v-if="questionError"
                    v-t="questionError"
                    class="
                        is-size-7
                        subtitle
                        mt-2
                        notification
                        is-danger is-light
                    "
                />
                <p
                    v-else
                    v-t="`creation.answer_type.${answerType}_description`"
                    class="
                        is-size-7
                        subtitle
                        mt-2
                        notification
                        is-success is-light
                    "
                />
            </div>
            <div v-if="answerType !== 'EMPTY'">
                <div v-for="index in createdAnswers.length" :key="index">
                    <div v-if="showAnswer(index)">
                        <hr />
                        <input-answer
                            v-model="createdAnswers[index - 1]"
                            :answer-type="answerType"
                            :disable-switch="
                                disabledAnswer(createdAnswers[index - 1])
                            "
                            @remove="removeAnswer(index - 1)"
                            @input="answersChanged"
                        />
                    </div>
                </div>
                <hr />
                <button
                    v-if="createdAnswers.length < creationSpacesCount"
                    v-t="'Buttons.add_question'"
                    class="is-white has-text-primary has-text-weight-bold"
                    @click="addAnswer"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
import InputAnswer from '@/components/InputAnswer';
import _ from 'underscore';
import {
    ANSWER_TYPES,
    DEFAULT_ANSWER_TYPE,
    EMPTY_ANSWER_TYPE,
} from '@/lib/constants';
export default {
    components: {
        InputAnswer,
    },
    props: {
        answers: {
            type: Array,
            default() {
                return [];
            },
        },
        answerType: {
            type: String,
            default: EMPTY_ANSWER_TYPE,
        },
        showCreation: { type: Boolean, default: false },
    },
    data() {
        return {
            containerClass: undefined,
            createdAnswers: [],
            answerTypes: ANSWER_TYPES,
            answerTypeLocal: this.answerType,
            previousAnswerTypeLocal: EMPTY_ANSWER_TYPE,
        };
    },
    computed: {
        creationSpacesCount() {
            if (this.answerType == 'HANGMAN' || this.answerType == 'FREETEXT') {
                return 1;
            } else {
                return Infinity;
            }
        },
        validAnswers() {
            return _.filter(this.answers, (answer) => {
                return answer && answer.value;
            });
        },
        disabledAnswer() {
            return (answer) => {
                if (
                    this.answerType == 'SINGLE' &&
                    _.some(this.validAnswers, (answer) => {
                        return answer.correct == true;
                    }) &&
                    answer &&
                    !answer.correct
                ) {
                    return true;
                }
                return false;
            };
        },

        questionError() {
            if (
                this.answerTypeLocal != 'EMPTY' &&
                this.previousAnswerTypeLocal != 'EMPTY' &&
                this.createdAnswers.length > 0
            ) {
                // only check for errors when exist almost one answer
                if (!this.validAnswers || !this.validAnswers.length) {
                    return this.answerType != 'MULTIPLE'
                        ? 'Object.errors.FILL_ANSWER'
                        : 'Object.errors.FILL_ANSWERS';
                }

                if (
                    !_.any(this.validAnswers, (answer) => {
                        return answer.correct == true;
                    })
                ) {
                    return 'Object.errors.MARK_CORRECT';
                }
            }
            return undefined;
        },
    },
    watch: {
        answerTypeLocal(newAnswerType, oldAnswerType) {
            /*if (newAnswerType == 'HANGMAN' || newAnswerType == 'FREETEXT') {
                this.createdAnswers = [
                    ..._.sortBy(this.createdAnswers, (answer) => {
                        return answer && answer.correct != true;
                    }),
                ];
                if (this.createdAnswers[0]) {
                    // to avoid validation error in simple answer creation
                    this.createdAnswers[0].correct = true;
                }
            } else {
                this.createdAnswers = [
                    ...this.createdAnswers.map((answer) => {
                        if (answer) {
                            answer.correct = false;
                            return answer;
                        }
                    }),
                ];
            }*/
            this.previousAnswerTypeLocal = oldAnswerType;
            this.$emit('update:answerType', newAnswerType);
            //if (!this.answers.length) {
            if (newAnswerType == 'HANGMAN' || newAnswerType == 'FREETEXT') {
                this.createdAnswers = new Array(1);
                this.answersChanged();
            } else {
                this.createdAnswers = new Array(3);
                this.answersChanged();
            }
            //}
        },
    },
    mounted() {
        this.createdAnswers = [...this.answers];
    },
    methods: {
        addAnswer() {
            this.createdAnswers.push({ value: undefined, correct: false });
        },
        removeAnswer(index) {
            this.createdAnswers.splice(index, 1);
        },
        answersChanged() {
            // console.log(this.createdAnswers);
            this.$emit('update:answers', _.compact(this.createdAnswers));
        },
        showAnswer(index) {
            // console.log('in Show answer');
            if (
                (this.answerType == 'HANGMAN' ||
                    this.answerType == 'FREETEXT') &&
                index > 1
            ) {
                return false;
            }
            return true;
        },
    },
};
</script>

<style scoped></style>
